import React from 'react';
import StudiesSendDetail from 'modules/Studies/StudiesSend/StudiesSendDetail';
import { IRequestsSendDetail } from './_types';

const RequestsSendDetail: React.FC<IRequestsSendDetail> = () => (
  <StudiesSendDetail isRequest={true} />
);

export default RequestsSendDetail;
